import React, { Component } from 'react';
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

class IncreaseInput extends Component {

    constructor(props) {
        super(props);
        this.state = {
            clicks: this.props.deafultText
        };
        this.IncrementItem = this.IncrementItem.bind(this);
        this.DecreaseItem = this.DecreaseItem.bind(this);
        this.onTriggerDown = this.onTriggerDown.bind(this);
        this.onTriggerUp = this.onTriggerUp.bind(this);
    }

    IncrementItem() {
        let x = ++this.state.clicks;
        this.props.parentCallback(x);
        this.setState({ clicks: x });
    }

    DecreaseItem() {
        if(this.state.clicks >= 1){
            let y = --this.state.clicks;
            this.props.parentCallback(y);
            this.setState({ clicks: y });
        }
    }

    onTriggerDown(event) {
        this.DecreaseItem();
        event.preventDefault();
    }

    onTriggerUp(event) {
        this.IncrementItem();
        event.preventDefault();
    }

    render() {

        const {
            textOne, textTwo, className, ...props
        } = this.props;

        return (
            <div className={`tw-flex tw-flex-wrap ${className}`}>
                <span className="tw-w-20 tw-mt-2 tw-text-left">{textOne}</span>
                <Link
                    to={'#'}
                    onClick={this.onTriggerDown}
                    className={'tw-px-2 tw-py-2 tw-bg-gray-400 hover:tw-bg-gray-500 h-fit-content'}
                >
                   <span className="material-icons tw-align-middle">remove</span>
                </Link>
                <p className={'tw-w-auto tw-px-4 tw-py-2'}>
                    {this.state.clicks}
                </p>
                <Link
                    to={'#'}
                    onClick={this.onTriggerUp}
                    className={'tw-px-2 tw-py-2 tw-bg-gray-400 hover:tw-bg-gray-500 h-fit-content'}
                >
                    <span className="material-icons tw-align-middle">add</span>
                </Link>
                <span className="tw-mt-2 tw-ml-4">{textTwo}</span>
            </div>
        );
    }
}

IncreaseInput.propTypes = {
    textOne: PropTypes.string,
    textTwo: PropTypes.string,
    className: PropTypes.string,
    deafultText: PropTypes.number,
};

export default IncreaseInput;

